import type { Theme } from "../tokens";

/** Mortuary card catalogue. A drawn grid, a case number per message. */
export const indexTheme: Theme = {
  id: "index",
  name: "Index",
  thesis: "Mortuary card catalogue. A drawn grid, a case number per message.",
  scheme: "light",
  colors: {
    ground: "#E8E6DF",
    surface: "#F4F2EC",
    raised: "#EDEAE2",
    ink: "#22211E",
    dim: "#5F5C54",
    rule: "#8C8880",
    lattice: "#C6C2B6",
    focus: "#22211E",
    inbox: "#8E1B1B",
    feed: "#3B4A3F",
    paperTrail: "#5F5C54",
    screener: "#7A3E8C",
  },
  type: {
    sans: "'IBM Plex Sans', system-ui, sans-serif",
    mono: "'IBM Plex Mono', ui-monospace, monospace",
    googleFonts: "IBM+Plex+Sans:wght@400;500;600&family=IBM+Plex+Mono:wght@400;500",
    tracking: "0.01em",
  },
  density: {
    row: 46,
    primary: 16,
    secondary: 15,
    meta: 13,
    listWidth: 0,
    rail: 224,
    radius: 0,
    lineHeight: 1.45,
  },
  markers: {
    inbox: "\u25A0",
    feed: "\u25A4",
    paperTrail: "\u25AD",
    screener: "\u25B2",
  },
};
